<div class="flex flex-col items-center gap-2 w-full">
  <span class="text-xs text-secondary mb-1">{{ label() }}</span>
  <div
    class="relative flex items-center justify-center"
    [style.width.px]="ringSizePx"
    [style.height.px]="ringSizePx"
  >
    <p-chart
      type="doughnut"
      [data]="chartData()"
      [options]="chartOptions"
      [width]="ringSizePx + 'px'"
      [height]="ringSizePx + 'px'"
    />
    <span class="absolute text-sm font-semibold">{{ completedSteps() }}</span>
  </div>
</div>
